import { Route } from '@angular/router';

export const randomCheckoutStatisticsRoutes: Route[] = [
    {
        path: 'random-checkout/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/random-checkout-statistics-details/random-checkout-statistics-details.component').then(
                (c) => c.RandomCheckoutStatisticsDetailsComponent
            ),
    },
    {
        path: 'random-checkout/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/random-checkout-statistics-games/random-checkout-statistics-games.component').then(
                (c) => c.RandomCheckoutStatisticsGamesComponent
            ),
    },
    {
        path: 'random-checkout/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/random-checkout-statistics-games-details/random-checkout-statistics-games-details.component'
            ).then((c) => c.RandomCheckoutStatisticsGamesDetailsComponent),
    },
];
